export const categories = [
    {
        id: "favorites",
        label: "Favorites",
        visible: false
    },
    {
        id: "recent",
        label: "Recent",
        visible: false
    },
    {
        id: "all",
        label: "All",
        visible: true,
        isClassicMenu: true,
        demoAllowed: true,
        classicOrder: 1,
    },
    {
        id: "new",
        label: "New",
        visible: true,
        isClassicMenu: true,
        demoAllowed: true,
        classicOrder: 2,
    },
    {
        id: "slots",
        label: "Slots",
        visible: true
    },
    {
        id: "arcade",
        label: "Arcade",
        visible: true,
        isClassicMenu: true,
        demoAllowed: true,
        classicOrder: 99,
    },
    {
        id: "lotteries",
        label: "Lotteries",
        visible: true,
        isClassicMenu: true,
        demoAllowed: true,
        classicOrder: 99,
    },
    {
        id: "videopoker",
        label: "Videopoker",
        visible: true,
        isClassicMenu: true,
        demoAllowed: true,
        classicOrder: 99,
    },
    {
        id: "sport",
        label: "Virtual Sport",
        visible: true
    },
    {
        id: "other",
        label: "Other",
        visible: true,
        isClassicMenu: true,
        classicOrder: 999,
    },
    {
        id: "live",
        visible: false,
    },
    {
        id: "tournaments",
        visible: false,
        isClassicMenu: true,
        classicOrder: 99,
    },
    {
        id: "pvp",
        visible: false,
    },
    {
        id: "live_pvp",
        label: "Live & PvP",
        visible: false,
        isClassicMenu: true,
        classicOrder: 99,
    }
];

const categoriesMap = categories.reduce((acc, curr) => {
    acc[curr.id] = 1;
    return acc;
}, {});

export const isOtherCategory = (cat) => {
    return cat === "other" || !categoriesMap[cat];
}
